import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES } from '@pingo/shared';
import { LANGUAGE_LABELS } from '../lib/i18n';

/**
 * Manual language switch (persisted in localStorage by the detector). `compact` = globe + 2-letter
 * code; on phones (≤ 480px) it shrinks to a 44px-high, 1px-bordered chip so the header title keeps
 * its line (`.lang-switcher--compact` in ui.css).
 */
export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { i18n, t } = useTranslation('common');
  const current = (i18n.resolvedLanguage ?? i18n.language ?? 'en').slice(0, 2);
  return (
    <label className={compact ? 'lang-switcher lang-switcher--compact' : 'lang-switcher'}>
      <span className="visually-hidden">{t('language')}</span>
      <span className="lang-switcher__icon" aria-hidden="true">
        <Globe size={16} />
      </span>
      <select
        className="ui-select"
        style={compact ? undefined : { width: 'auto', minWidth: 156 }}
        value={current}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
        aria-label={t('language')}
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l} value={l}>
            {compact ? l.toUpperCase() : LANGUAGE_LABELS[l]}
          </option>
        ))}
      </select>
    </label>
  );
}
